import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Title, SafeHtml } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';

import { TableComponent } from '../shared/table/table.component';
import { SystemMessageService } from '../core/system-message/system-message-service';
import { HelpFilesVm } from '../shared/generated/HelpFiles/Models/HelpFilesVm';
import { SecurityService } from '../core/security/security.service';
import { CheckNetworkService } from 'local-db/services/check-network.service';

@Component({
    selector: 'pcg-help-files',
    templateUrl: './help-files.component.html',
    styleUrls: ['./help-files.component.scss'],
    standalone: false
})
export class HelpFilesComponent implements OnInit {

	@ViewChild(TableComponent, { static: true }) table: TableComponent<HelpFilesVm>;
	@ViewChild('helpfile', { static: false }) modalContent: TemplateRef<any>;
	@ViewChild('helpvideo', { static: false }) modalVideoContent: TemplateRef<any>;

	columns = HelpFilesVm.ColumnDefs;
	formGroup = HelpFilesVm.Form;
	strName: SafeHtml;

	canCreateEditDelete = false;
	isOnline: boolean;

	mobileColHeads = {
		delete: "Delete"
	};

	constructor(
		public title: Title
		, private httpClient: HttpClient
		, public modalService: NgbModal
		, public ms: SystemMessageService
		, private sec: SecurityService
	) { title.setTitle('Help'); }

	ngOnInit() {
		this.isOnline = CheckNetworkService.checkNetworkStatus();
		this.canCreateEditDelete = this.sec.hasAccess(o => o.manageHelpDocumentation);
		if (!this.canCreateEditDelete) {
			this.columns.delete('delete');
			this.columns.delete('helpFileId');
		}
	}

	generateUrl(name: string, videoid: number) { return '/help/help-video/' + videoid; }

	openModal(id: number, videoId: number = null) {
		// Remove validators for source file
		this.formGroup.controls['sourceFile'].clearValidators();
		this.formGroup.controls['sourceFile'].updateValueAndValidity();

		if (videoId !== null) {
			this.formGroup.controls['file'].clearValidators();
			this.formGroup.controls['file'].updateValueAndValidity();
			this.modalService.open(this.modalVideoContent, { beforeDismiss: () => { this.formGroup = HelpFilesVm.Form; return true; } });
		} else {
			this.formGroup.controls['videoId'].clearValidators();
			this.formGroup.controls['videoId'].updateValueAndValidity();
			this.modalService.open(this.modalContent, { beforeDismiss: () => { this.formGroup = HelpFilesVm.Form; return true; } });
		}

		if (id !== 0) {
			this.httpClient.get(`api/HelpFiles/HelpFiles/GetDetails/${id}`).subscribe((model: HelpFilesVm) => {
				this.formGroup.patchValue(model);
				this.formGroup.controls['file'].clearValidators();
				this.formGroup.controls['file'].updateValueAndValidity();
				if (videoId != null) {
					this.formGroup.controls['sourceFile'].clearValidators();
					this.formGroup.controls['sourceFile'].updateValueAndValidity();
				} else {
					this.formGroup.controls['videoId'].clearValidators();
					this.formGroup.controls['videoId'].updateValueAndValidity();
				}
			});
		}
	}
}

